// extracted by mini-css-extract-plugin
module.exports = {"globals":"\"../GlobalStyles.css\"","screen-xs":"640px","screen-sm":"1024px","defaultTiming":"ease-out","viewerAnimation":"1s ease-out 1s"};